import {http} from '../http'
import * as coreAuth from '../../coreApi/auth'

import {APIResponse} from '../types'
import {ClientUser} from '../../../types'
import {handleError} from '../handleError'

interface ExchangeParams {
  accessToken: string
  clientID: string
}

type ResolvedReturn = APIResponse<ClientUser>

export interface Exchange {
  (params: ExchangeParams): Promise<APIResponse<ClientUser>>
}

const ERROR_PATH = 'api.auth.exchange()'
const GENERIC_ERROR = 'Something went wrong during login. Please try again.'

export const exchange: Exchange = async ({accessToken, clientID}) => {
  let resolvedReturn: ResolvedReturn

  try {
    const response = await coreAuth.exchange(http, {
      accessToken,
      origin: 'system',
      clientID: Number(clientID),
    })

    if (
      response.data.Status === 'Success' &&
      response.data.ClientUsers.length > 0
    ) {
      const {ClientID, PersonID} = response.data.ClientUsers[0]

      resolvedReturn = {
        result: 'success',
        data: {
          clientID: ClientID.toString(),
          personID: PersonID.toString(),
        },
      }
    } else {
      throw new Error('Unable to exchange access token for legacy JWT')
    }
  } catch (e) {
    resolvedReturn = handleError(ERROR_PATH, GENERIC_ERROR, e)
  }
  return Promise.resolve(resolvedReturn)
}
